export default __webpack_public_path__ + "static/media/only-win-stamp.91fa204e.webp";